import logo from './logo.png';
import './App.css';
import ChatBot from './components/ChatBot';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <a href="https://pousadahortelapimenta.com.br/" rel="noreferrer" target="_blank"><img src={logo} className="App-logo" alt="logo" /></a>
      </header>
      <main className="App-main h-screen max-h-screen overflow-y-auto p-4 bg-gray-100">
        <ChatBot />
      </main>
    </div>
  );
}

export default App;
